import { type FC } from 'react';
import { format } from 'date-fns';
import { Divider, Form } from 'antd';

import { Button, Space } from '@g2u/ui-kit';
import { Condition, Technician } from 'types';
import {
  TechnicianAddressFields,
  TechnicianAdministrationFields,
  TechnicianContactsFields,
  TechnicianDetailsFields,
} from 'components';

type Props = Readonly<{
  technician: Technician;
  onUpdate: (payload: any) => void;
}>;

export const TechnicianDetails: FC<Props> = (props: Props) => {
  const { technician, onUpdate } = props;
  const [detailsForm] = Form.useForm();

  const handleUpdateTechnician = (
    data: Partial<
      Technician & {
        homeAddressLine1?: string;
        homeAddressLine2?: string;
        homeAddressPostcode?: string;
        homeAddressState?: string;
        homeAddressSuburb?: string;
        postalAddressLine1?: string;
        postalAddressLine2?: string;
        postalAddressPostcode?: string;
        postalAddressState?: string;
        postalAddressSuburb?: string;
        companyName?: string;
      }
    >,
  ) => {
    onUpdate({
      ...data,
      same_address: data.same_address ? Condition.Yes : Condition.No,
      date_started: data.date_started ? format(data.date_started, 'yyyy-MM-dd') : null,
      date_finished: data.date_finished ? format(data.date_finished, 'yyyy-MM-dd') : null,
      company: data.companyName?.trim() || null,
      physical_address_line1: data.homeAddressLine1,
      physical_address_line2: data.homeAddressLine2,
      physical_postcode: data.homeAddressPostcode?.toString(),
      physical_state: data.homeAddressState,
      physical_suburb: data.homeAddressSuburb,
      postal_address_line1: data.postalAddressLine1,
      postal_address_line2: data.postalAddressLine2,
      postal_postcode: data.postalAddressPostcode?.toString(),
      postal_state: data.postalAddressState,
      postal_suburb: data.postalAddressSuburb,
      ID: technician?.ID,
    });
  };
  return (
    <>
      <title>Update Technician Details</title>
      <Form
        form={detailsForm}
        name="details-form"
        layout="horizontal"
        onFinish={handleUpdateTechnician}
        colon={false}
        preserve={true}
      >
        <TechnicianAdministrationFields technician={technician} inline />
        <Divider />
        <TechnicianDetailsFields technician={technician} inline />
        <Divider />
        <TechnicianContactsFields technician={technician} inline />
        <Divider />
        <TechnicianAddressFields technician={technician} inline />
        <Divider />
        <Space.$ justify={Space.Justify.End}>
          {/* <Text.$ accent>Last updated: n/a</Text.$>  // To be implemented when API is ready */}
          <Button.$ dataTestId="update-technician" type={Button.Type.Primary} onClick={() => detailsForm.submit()}>
            Save
          </Button.$>
        </Space.$>
      </Form>
    </>
  );
};
